import { render } from "./PrintRestaurantVoucher.vue?vue&type=template&id=59a99c9b&scoped=true"
import script from "./PrintRestaurantVoucher.vue?vue&type=script&lang=js"
export * from "./PrintRestaurantVoucher.vue?vue&type=script&lang=js"

import "./PrintRestaurantVoucher.vue?vue&type=style&index=0&id=59a99c9b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59a99c9b"

export default script